import * as React from 'react';
import {Button} from "antd";
import usePortalService from '../../services/PortalService';
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { ReactionResolveOption } from "../../Enums/ReactionResolveOption";
import { ReactionFilterOption } from "../../Enums/ReactionFilterOption";
import { ReactionResolve } from "../../types";
import { StyledModal } from './StyledModal';

export const DenyReaction = ({isOpen, close, reactionId, setStatus}: ReactionResolve) => {
	const { resolveToReaction } = usePortalService();
	const [message, setMessage] = useState('');

	const applyHandler = async (e: React.MouseEvent<HTMLElement>) => {
		e.stopPropagation();
		const result = await resolveToReaction({
			reactionId,
			reactionResolveOption: ReactionResolveOption.Reject,
			message
		})
		if (result.success) {
			setStatus(ReactionFilterOption.RejectReactions)
			close();
		}
	};

	return(
		<StyledModal 
			title="Отказать кандидату" 
			open={isOpen}
			footer={[
				<Button onClick={close} style={{marginRight: '6px'}} key="back">Отмена</Button>,
				<Button danger onClick={e => applyHandler(e)} key="submit">Отказать</Button>
			]}
			onCancel={close}
		>
			<p>Текст сообщения</p>
			<TextArea rows={12} value={message} onChange={e => setMessage(e.target.value)}/>
		</StyledModal>
	)
}